import { io } from 'socket.io-client';
import { CustomErrorClass, ErrorSeverity } from '../errors';
import { SOCKET_IO_RECONNECTION_DELAY } from '../constants';
export class WebSocketConnection {
    constructor(options) {
        this.isReconnecting = false;
        this.url = options.url;
        this.authenticationToken = options.authenticationToken;
        this.onConnect = options.onConnect;
        this.onDisconnect = options.onDisconnect;
        this.onBotResponse = options.onBotResponse;
        this.onSessionConfirm = options.onSessionConfirm;
        const ioOptions = {
            autoConnect: false,
            reconnectionDelay: SOCKET_IO_RECONNECTION_DELAY,
            reconnectionDelayMax: SOCKET_IO_RECONNECTION_DELAY,
        };
        if (this.authenticationToken) {
            ioOptions.auth = {
                token: this.authenticationToken,
            };
        }
        this.socket = io(options.url, ioOptions);
        this.initEvents();
    }
    connect() {
        this.socket.connect();
    }
    sendMessage(message, sessionId) {
        this.socket.emit('user_uttered', { message, session_id: sessionId });
    }
    disconnect() {
        this.socket.disconnect();
    }
    sessionRequest(sessionId) {
        this.socket.emit('session_request', {
            session_id: sessionId,
        });
    }
    reconnection(value) {
        this.socket.io.reconnection(value);
        if (this.socket.connected === false && this.socket.io._reconnecting) {
            this.socket.disconnect();
        }
    }
    initEvents() {
        this.socket.on('connect', () => {
            this.onConnect(this.isReconnecting);
            this.isReconnecting = false;
        });
        this.socket.on('disconnect', () => {
            this.onDisconnect();
            this.isReconnecting = false;
        });
        this.socket.on('bot_uttered', (data) => {
            this.onBotResponse(data);
        });
        this.socket.on('session_confirm', () => {
            this.onSessionConfirm();
        });
        this.socket.io.on('reconnect', _ => {
            this.isReconnecting = true;
        });
        this.socket.on('connect_error', () => {
            setTimeout(() => {
                throw new CustomErrorClass(ErrorSeverity.Error, 'Server error');
            }, 0);
        });
        this.socket.io.on('reconnect_attempt', attemptNumber => {
            console.log(`Reconnection attempt #${attemptNumber}`);
        });
    }
}
//# sourceMappingURL=WebSocketConnection.js.map